import { React, useState } from 'react';
import MainLayout from 'layouts/MainLayout';
import FormWrapper from "components/forms/FormWrapper";
import FormAutosave from "components/forms/FormAutosave";
import { TabPanel, TabView } from 'primereact/tabview';
import _ from "lodash";
import {InputTextarea} from "primereact/inputtextarea";
import { useListDepartmentsQuery } from 'apis/departmentApi';
import { useListDepartmentUser } from 'hooks/taskHooks';
import StepsTable from '../_Components/StepsTable/StepsTable';

import { useUpdateSurveyMutation } from "../../../apis/surveyApi";
import { useUserProfileQuery } from 'apis/authenticationApi';
import { Message } from 'primereact/message';

const StandardsGuidelinesAssessmentPage = ({ editObject }) => {

	const [updateSurvey, status] = useUpdateSurveyMutation();
	const {data:  departments} = useListDepartmentsQuery();
	const departmentResponsible = useListDepartmentUser();

	const [activeIndex, setActiveIndex] = useState(0);
	const {data: userProfile} = useUserProfileQuery();
	const canEdit = ['CompanyOwner'].includes(userProfile?.company?.role);

	const handleSubmit = (data) => {
		const clonedData = _.cloneDeep(data);
		updateSurvey({ type: editObject.type, data: clonedData });
	}

	const savedMsgContent = status?.status === 'fulfilled' && <Message style={{width:"100%"}} severity="success" text="Section Auto-Saved with success" />;

	return (
		<MainLayout>
			<div className="standardsGuidelines">
				<FormWrapper type="MarketingStrategy" editObject={editObject?.data || { targetAudience: 'consumer' }} handleSubmit={handleSubmit}
					renderForm={(formik) =>
					(<form className="formgrid grid">
						<FormAutosave formik={formik} autoSubmitMilliseconds={1000} />
						<TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
							<TabPanel header="WHO We Are">
								<h2>Our Core Business (WHAT we do):</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="WHAT we do" id="businessWhat" name="businessWhat" className="inputfield w-full" value={formik.values?.businessWhat} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessWhat}
									</span>
								</div>
								<h2>Our Business Purpose:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="WHY we do what we do" id="businessWhy" name="businessWhy" className="inputfield w-full" value={formik.values?.businessWhy} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessWhy}
									</span>
								</div>
								<h2>Our Business Justification:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="What VALUE we offer customers/clients" id="businessValue" name="businessValue" className="inputfield w-full" value={formik.values?.businessValue} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessValue}
									</span>
								</div>
								<h2>Our Business Success:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="How we define if we're SUCCESSFUL or not" id="businessSuccess" name="businessSuccess" className="inputfield w-full" value={formik.values?.businessSuccess} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessSuccess}
									</span>
								</div>
								<h2>Our BHAG Statement:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="The one significant longer-term goal/milestone we're striving to achieve - it should drive all of our actions and decisions to keep us focused on reaching our full potential" id="businessBhag" name="businessBhag" className="inputfield w-full" value={formik.values?.businessBhag} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessBhag}
									</span>
								</div>
							<br/>

							<StepsTable
									title="Core Values"
									description={"Our non-negotiable values, principles, beliefs and behaviors that guide our decisions and define \"WHO\" we are as a business and \"HOW\" we conduct our business."}
									indexColumnName="Value No"
									name="coreValues"
									formik={formik}
									disabled={!canEdit}
							/>
							{savedMsgContent}
							</TabPanel>
							<TabPanel header="Primary Customer/Client">
								<StepsTable
										title="Demographics"
										description={"Descriptive statistical information related to our primary customer or client."}
										indexColumnName="Demographic No"
										name="demographics"
										formik={formik}
										disabled={!canEdit}
								/>
								<br/>
								<StepsTable
									title="Geographics"
									description="Physical and digital locations where our primary customer or client resides and/or can be reached, etc."
									indexColumnName="Geographic No"
									name="geographics"
									formik={formik}
									disabled={!canEdit}
								/>
								<br/>
								<StepsTable
									title="Physchographics"
									description="Emotional characteristics that influence our customer's preferences and decisions: their priorities, beliefs, values, attitudes, habits, interests, hobbies, aspirations, etc."
									indexColumnName="Physchographic No"
									name="physchographics"
									formik={formik}
									disabled={!canEdit}
								/>
							{savedMsgContent}
							</TabPanel>

							<TabPanel header="Marketing & Sales">
								<h2>Our Primary Brand:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="Our most important, dominating, headlining brand when reaching out to potential and existing customers" id="businessBrand" name="businessBrand" className="inputfield w-full" value={formik.values?.businessBrand} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessBrand}
									</span>
								</div>
								<h2>Our One-and-Only:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="The ONE THING our business/product/service, and only our business/product/ service, can claim to do - something NO ONE ELSE can say - our Differentiator" id="businessDifferentiator" name="businessDifferentiator" className="inputfield w-full" value={formik.values?.businessDifferentiator} onChange={formik.handleChange} disabled={!canEdit}/>
									</span>
									<span className="printing">
										{formik.values?.businessDifferentiator}
									</span>
								</div>
								<h2>Our Guarantee:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="The promise we make to our customers or clients" id="businessGuarantee" name="businessGuarantee" className="inputfield w-full" value={formik.values?.businessGuarantee} onChange={formik.handleChange} disabled={!canEdit} />
									</span>
									<span className="printing">
										{formik.values?.businessGuarantee}
									</span>
								</div>
								<br/>
								<StepsTable
									title="Top Elevator Pitch Messages:"
									description="Our MAIN MESSAGE points that can be easily, quickly and consistently conveyed to an important prospect."
									indexColumnName="Message No"
									name="mainMessage"
									formik={formik}
									disabled={!canEdit}
								/>
								<h2>Our Primary Call-to-Action:</h2>
								<div className="field col-12">
									<span className="non-printing">
										<InputTextarea autoResize placeholder="The main 'action' we want prospects to take as a result of receiving our messages - our strongest, most consistent method for capturing relevant information and converting prospects" id="businessCta" name="businessCta" className="inputfield w-full" value={formik.values?.businessCta} onChange={formik.handleChange} disabled={!canEdit} />
									</span>
									<span className="printing">
										{formik.values?.businessCta}
									</span>
								</div>
								{savedMsgContent}
							</TabPanel>

							<TabPanel header="Key Processes & Procedures">
								<StepsTable
									title="Key Processes & Procedures."
									description="Our primary processes have been defined, simplified and documented to ensure our efforts, activities, time and resources consistently produce the expected outcome(s) in the most effective and efficient manner."
									indexColumnName="Process Number"
									name="processesProcedures"
									disabled={!canEdit}
									hideSteps={false}
									topAligned={true}
									valuesList={[
										{
											key: "processName",
											label: "Process Name",
											inputPlaceholder: "Name"
										},
										{
											key: "stepDetail",
											label: canEdit? "Edit Steps" : "View Steps",
											inputType: "Button",
											editComponent: <StepsTable
															indexColumnName="Step No"
															disabled={!canEdit}
															hideSteps={false}
															addRowName={"Add Step"}
															topAligned={true}
															valuesList={[
																{
																	key: "toBeDone",
																	label: "To do",
																	detail: "What needs to be done",
																	inputType: "InputTextarea",
																	inputPlaceholder: "- Description\n- Supporting Info\n- Equipment Info\n- File Info\n- Any Special Skills or Training"
																},
																{
																	key: "whenStepBegins",
																	label: "Action Trigger",
																	detail: "WHEN does this step begin - What initiates the action",
																	inputType: "InputTextarea",
																	inputPlaceholder: "What Initiates this action"
																},
																{
																	key: "responsibleDepartment",
																	label: "Department",
																	inputType: "Dropdown",
																	inputOptions: (departments || []).map(e => ({key: e.id, label: e.name})),
																	detail: "Which DEPARTMENT is responsible for this step",
																	inputPlaceholder: "- Select one -"
																},
																{
																	key: "responsiblePerson",
																	label: "Responsible Person",
																	inputType: "Dropdown",
																	inputOptions: (rowValues) => {
																		const departmentData = (departmentResponsible || []).filter(department => rowValues?.responsibleDepartment && department?.id === rowValues?.responsibleDepartment);
																		return (departmentData?.[0]?.userList || []).map(e => ({key: e.id, label: ((e?.firstName ?? "" + " " + e?.lastName ?? "") || e?.email) }));

																	},
																	detail: "WHO (role, title or person) in this department is responsible for this step",
																	inputPlaceholder: "- Select one -"
																},
																{
																	key: "doneDefinition",
																	label: "When is complete",
																	detail: "Describe how you know when this step is completed",
																	inputType: "InputTextarea",
																	inputPlaceholder: "- Anything Produced\n- Anything Sent or Saved\n- Any Confirmations\n- Any Communications"
																}
															]}
															formik={formik}
														/>
										}
									]}
									formik={formik}
								/>

							{savedMsgContent}
							</TabPanel>
						</TabView>



					</form>



					)
					}>
				</FormWrapper>
			</div>
		</MainLayout>)
	//}

}

export default StandardsGuidelinesAssessmentPage;
